import React, { useState } from "react";
import "./style.css";
import utu_logo from "../images/utu.png";
import tvo_logo from "../images/tvo.png";
import luvata_logo from "../images/luvata.png";
import styled from "styled-components";

const EmailLink = styled.a`
  color: #d8d8d8;
`;

const experience = [
  {
    company: "Teollisuuden Voima Oyj",
    role: "DevOps Specialist",
    period: "March 2025 - Present",
    description:
      "Leading the development and implementation of CI/CD pipelines, overseeing end-to-end processes including software testing practices, quality assurance, and Agile/Scrum development workflows in multiple projects",
    logo: tvo_logo,
  },
  {
    company: "Teollisuuden Voima Oyj",
    role: "M.Sc. (Tech) Thesis Worker",
    period: "August 2024 - March 2025",
    description:
      "Research on Machine Learning applications for radiation safety in Nuclear Power Plants, developing predictive models to estimate personnel radiation doses in various work tasks",
    logo: tvo_logo,
  },
  {
    company: "Teollisuuden Voima Oyj",
    role: "DevOps Trainee",
    period: "May 2024 - August 2024",
    description:
      "Set up initial Scrum workflows and developed DevOps practices, integrating Agile development with CI/CD and Kubernetes to ensure maintainable, high-quality software",
    logo: tvo_logo,
  },
  {
    company: "Teollisuuden Voima Oyj",
    role: "Information System Services Trainee",
    period: "May 2023 - September 2023",
    description:
      "Introduced and configured version control system for TVO and drove the initial development of CI/CD pipelines with Kubernetes, establishing modern development practices",
    logo: tvo_logo,
  },
  {
    company: "Luvata Pori Oy",
    role: "Helpdesk Technician",
    period: "May 2022 - August 2022",
    description:
      "System, software, user, and device support, including the installation of workstations and troubleshooting problem situations in industrial setting",
    logo: luvata_logo,
  },
];

const education = [
  {
    institution: "University of Turku",
    award: "Master of Science (Technology)",
    field: "Biomedical Engineering and Health Technology, Health Technology",
    period: "September 2023 - March 2025",
    logo: utu_logo,
  },
  {
    institution: "University of Turku",
    award: "Bachelor of Science",
    field: "Computer Science",
    period: "September 2021 - May 2023",
    logo: utu_logo,
  },
];

function TimelineItem({ item, type }) {
  const [open, setOpen] = useState(false);

  const titleLeft =
    type === "edu" ? item.institution : item.company;
  const titleRight =
    type === "edu" ? item.award : item.role;

  return (
    <div className={`timeline-item ${open ? "open" : ""}`}>
      <button
        className="timeline-hit"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={`tl-content-${titleLeft}-${titleRight}`}
      >
        <div className="timeline-icon" aria-hidden="true">
          <img
            src={item.logo}
            alt=""
          />
        </div>

        <div className="timeline-heading">
          <span className="accent">{titleLeft}</span>
          <span className="sub">{titleRight}</span>
          <span className="timeline-period">{item.period}</span>
        </div>

        <div className="timeline-chevron" aria-hidden="true">
          <span className="chev" />
        </div>
      </button>

      <div
        id={`tl-content-${titleLeft}-${titleRight}`}
        className="timeline-content"
        role="region"
        aria-label={`${titleLeft} ${titleRight} details`}
      >
        {type === "edu" ? (
          <p className="timeline-desc">{item.field}</p>
        ) : (
          <p className="timeline-desc">{item.description}</p>
        )}
      </div>
    </div>
  );
}

function TimelineSection({ title, items, type }) {
  return (
    <div className="timeline-section">
      <h1 className="timeline-title">{title}</h1>
      <div className="timeline-container">
        {items.map((it, i) => (
          <TimelineItem key={`${title}-${i}`} item={it} type={type} />
        ))}
      </div>
    </div>
  );
}

export default function Timeline() {
  return (
    <section id="timeline">
      <TimelineSection title="Experience" items={experience} type="exp" />
      <TimelineSection title="Education" items={education} type="edu" />
      <div>
        <div id="textcont-container">
          <div id="textcont-content">
            <h2 id="textcont-sub-title">TL;DR</h2>
            All the stuff related to AI and making quality and maintainable software!
          </div>
          <div id="textcont-content">
            <h2 id="textcont-sub-title">... How to contact me?</h2>
            You can find my socials by clicking the buttons above! The easiest way to get in touch with me is to use my <EmailLink href="mailto:puuval@puuval.me">email</EmailLink>.
          </div>
        </div>
      </div>
    </section>
  );
}